import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAdminEventView({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/AdminEventView"));
  console.log("Loading", AsyncAdminEventView.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAdminEventView;
